import { StructuredText, StructuredTextGraphQlResponse } from 'react-datocms'
import styled from 'styled-components'

export const StyledOverrideDefaultStyles = styled.div`
  p {
    font-size: var(--font-size-fluid-paragraph-300);
    line-height: var(--line-height-fluid-paragraph-300);
    font-weight: var(--font-weight-fluid-paragraph-300);
    font-family: var(--font-sans-serif-light), var(--font-fallback-sans-serif);
    margin: 0;
  }
  a {
    font-family: var(--font-sans-serif-semibold), var(--font-fallback-sans-serif);
    color: var(--color-text-link);
    text-decoration: none;
  }
  strong,
  b {
    font-family: var(--font-sans-serif-semibold), var(--font-fallback-sans-serif);
    font-weight: var(--font-sans-serif-semibold-weight);
  }
  h1,
  h2,
  h3,
  h4,
  h5 {
    margin-top: 0;
    margin-bottom: var(--grid-24);
  }
  h1 {
    font-size: var(--font-size-fluid-heading-900alt);
    line-height: var(--line-height-fluid-heading-900alt);
    font-weight: var(--font-sans-serif-semibold-weight);
    font-family: var(--font-sans-serif-semibold), var(--font-fallback-sans-serif);
  }
  h2 {
    font-size: var(--font-size-fluid-heading-800);
    line-height: var(--line-height-fluid-heading-800);
    font-weight: var(--font-sans-serif-semibold-weight);
    font-family: var(--font-sans-serif-semibold), var(--font-fallback-sans-serif);
  }
  h3 {
    font-size: var(--font-size-fluid-heading-700);
    line-height: var(--line-height-fluid-heading-700);
    font-weight: var(--font-sans-serif-semibold-weight);
    font-family: var(--font-sans-serif-semibold), var(--font-fallback-sans-serif);
  }
  h4 {
    font-size: var(--font-size-fluid-heading-600);
    line-height: var(--line-height-fluid-heading-600);
    font-weight: var(--font-sans-serif-semibold-weight);
    font-family: var(--font-sans-serif-semibold), var(--font-fallback-sans-serif);
  }
  h5 {
    font-size: var(--font-size-fluid-heading-500);
    line-height: var(--line-height-fluid-heading-500-alt);
    font-weight: var(--font-sans-serif-semibold-weight);
    font-family: var(--font-sans-serif-semibold), var(--font-fallback-sans-serif);
  }
  ul,
  ol {
    margin: 0;
    padding-left: 20px;
  }
  li {
    font-size: var(--font-size-fluid-paragraph-300);
    line-height: var(--line-height-fluid-paragraph-300);
    font-weight: var(--font-sans-serif-regular-weight);
    font-family: var(--font-sans-serif-regular), var(--font-fallback-sans-serif);
    margin-bottom: var(--grid-24);
    &:last-child {
      margin-bottom: 0;
    }
  }
`

interface DSStyledStructuredTextProps {
  data: StructuredTextGraphQlResponse
}

export const DSStyledStructuredText = ({ data }: DSStyledStructuredTextProps) => {
  return (
    <StyledOverrideDefaultStyles>
      <StructuredText data={data} />
    </StyledOverrideDefaultStyles>
  )
}
